import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {contrastColor} from "../theme";

const SectionBox = ({children,  contrast, gutterBottom=true, gutterTop=true}) => {
    const classes = useStyles();

    return <div className={clsx(classes.sectionBoxRoot, {
        [classes.gutterBottom]: gutterBottom,
        [classes.gutterTop]: gutterTop,
        [classes.contrast]: contrast,
        ["contrast-section"]: contrast,
    })}>
        <div className={clsx(classes.sectionBoxInner, {

        })}>
            {children}
        </div>
    </div>
}

const useStyles = makeStyles((theme) => ({
    sectionBoxRoot: {
        position: "relative",
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(1),
        borderRadius:'16px',
    },
    sectionBoxInner: {
        position: "relative",
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(1),
        borderRadius:'16px',
    },
    contrast: {
        backgroundColor: contrastColor,
    },
    gutterBottom: {
        paddingBottom:  theme.spacing(4),
    },
    gutterTop: {
        paddingTop: theme.spacing(5),
    },

}));
export default SectionBox
